// Dropdown

// Dropdown click event
document.querySelectorAll('.heading').forEach((element, index) => {
  element.parentElement.style.height = element.parentElement.clientHeight + "px";
  element.addEventListener('click', function () {
    let inital_height = element.parentElement.querySelector('.heading').clientHeight + 40;
    let final_height = inital_height + element.parentElement.querySelector('.text').clientHeight + 20;
    if (element.parentElement.querySelector('.text').classList.contains('visible')) {
      element.parentElement.style.height = inital_height + "px";
    } else {
      element.parentElement.style.height = final_height + "px";
    }

    // si element ne contient pas active ferme tous les autres élements, on passe cette boucle si on clique sur le meme dropdown pour fair un simple toggle 
    // if (!element.classList.contains('active') && document.querySelector('.heading.active') != null) {
    //   let active = document.querySelector('.heading.active');
    //   active.classList.remove('active');
    //   active.parentElement.querySelector('.text').classList.remove('visible');
    //   active.parentElement.querySelector('.cross-bar').classList.remove('active');
    //   active.parentElement.style.height = inital_height + "px";
    // }

    // toggle basique sur un seul dropdown
    element.classList.toggle('active');
    element.parentElement.querySelector('.text').classList.toggle('visible');
    element.parentElement.querySelector('.cross-bar').classList.toggle('active');
    if (element.parentElement.querySelector('.text').classList.contains('composition')) {
      element.parentElement.style.height = "auto";
    } else {
      element.parentElement.style.height = +"px";
    }
  });
});

// Open first dropdown item by default
document.querySelectorAll('.dropdown__container-product.first-dropdown, .dropdown__container.first-dropdown').forEach(function (element) {
  element.style.height = "auto";
  element.querySelector('.heading').classList.add('active');
  element.querySelector('.text').classList.add('visible');
  element.querySelector('.cross-bar').classList.add('active');
});